import { render } from "./FaqManageListPage.vue?vue&type=template&id=e3b62e50&lang=true"
import script from "./FaqManageListPage.vue?vue&type=script&lang=js"
export * from "./FaqManageListPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__